export const getCookieDomain = () => {
  return document.location.host.replace(/^www\./, '');
};
